import { render } from "./newscontent.vue?vue&type=template&id=688715dc&scoped=true"
import script from "./newscontent.vue?vue&type=script&lang=js"
export * from "./newscontent.vue?vue&type=script&lang=js"

import "./newscontent.vue?vue&type=style&index=0&id=688715dc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-688715dc"

export default script